import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconGoToOutline({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0zm0 1.125a7.875 7.875 0 1 0 0 15.75 7.875 7.875 0 0 0 0-15.75zm2.18 3.474.074.064 3.777 3.943a.559.559 0 0 1 .123.2l.009.029c.006.018.01.035.014.053l.005.036a.58.58 0 0 1 .005.063v.027l-.001.03v-.031l-.003.052-.007.047a.517.517 0 0 1-.012.053l-.01.03a.537.537 0 0 1-.072.137l-.051.062-3.777 3.943a.519.519 0 0 1-.756 0 .576.576 0 0 1-.062-.712l.062-.077 2.862-2.986H3.375a.563.563 0 0 1 0-1.124l9.985-.001-2.862-2.985a.576.576 0 0 1-.062-.711l.062-.078a.518.518 0 0 1 .682-.064z"/>
        </svg>
    );
}

export default IconGoToOutline;
